<div class="row">
  <h2 class="col-12">Bonjour,</h2>
  <h2 class="col-12">{{user.firstname}} {{user.lastname}}</h2>
    <div class="col-12">
      <div class="round-img">
        <img src="assets/img/Picto_Global/logoclem.png" alt="clem">
      </div>
    </div>
</div>
<!-- <mat-card class="row box-shadow">
  <mat-card-header class=" row col-12">
    <mat-card-title class="col-12">

    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <div class="row ">
            <div class="col-12">

              <h5 class="col-12">{{user.firstname}} {{user.lastname}}</h5>
              <h3 class="col-12">Mes services</h3>
              <table class="col-12">
                <tr>
                  <th>
                    <mat-icon svgIcon="autopartage"></mat-icon>
                  </th>
                  <th>
                    <mat-icon svgIcon="recharge"></mat-icon>
                  </th>
                  <th>
                    <mat-icon svgIcon="partage-trajet"></mat-icon>
                  </th>
                </tr>
                <tr>
                  <td>
                    <div *ngIf="user.autopartage; else NoAutopargeBlock">
                      <div *ngIf="user.permis; else NoPermisBlock">
                        <mat-icon style="color: green">check</mat-icon>
                      </div>
                      <ng-template #NoPermisBlock>
                        <mat-icon style="color: orange" matTooltip="Permis non validé">warning</mat-icon>
                      </ng-template>
                    </div>
                    <ng-template #NoAutopargeBlock>
                      <mat-icon style="color: red" matTooltip="service non selectionné">cancel</mat-icon>
                    </ng-template>
                  </td>
                  <td>
                    <div *ngIf="user.recharge; else NoAutopargeBlock">
                      <mat-icon style="color: green">check</mat-icon>
                    </div>
                    <ng-template #NoAutopargeBlock>
                      <mat-icon style="color: red " matTooltip="service non selectionné">cancel</mat-icon>
                    </ng-template>
                  </td>
                  <td>
                    <div *ngIf="user.partage_trajet; else NoAutopargeBlock">
                      <mat-icon style="color: green">check</mat-icon>
                    </div>
                    <ng-template #NoAutopargeBlock>
                      <mat-icon style="color: red" matTooltip="service non selectionné">cancel</mat-icon>
                    </ng-template>
                  </td>
                </tr>
              </table>
              <!-- <h4 class="col-12">Status du compte</h4>
                <table class="col-12">
                  <tr>
                    <th>
                      permis
                    </th>
                    <th>
                      caution
                    </th>
                    <th>
                      CGU
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <mat-icon>check</mat-icon>
                    </td>
                    <td>
                      <mat-icon>check</mat-icon>
                    </td>
                    <td>
                      <mat-icon>cancel</mat-icon>
                    </td>
                  </tr>
                </table> -->


        <!-- <div class="col-12 col-md-6 bordered">
              <app-next-book [bookList]=_bookList (_openMapEvent)='displayLeafletDialog($event)'></app-next-book> -->

        <!--  -->



        <!-- <div class="col-md-3 col-12 user-info">
            <h4 class="col-12">Information générales</h4>
            <h5 class="col-12">
              <mat-icon aria-hidden="false">email</mat-icon> : {{_user.email}}
            </h5>
            <h5 class="col-12">
              <mat-icon aria-hidden="false">phone</mat-icon> : {{_user.phonenumber}}
            </h5>
            <h4 class="col-12">Information de payement</h4>
            <div *ngIf="_user.paymode == 'paydebit'">
              <h5 class="col-12">
                type de payement: Prélèvement
              </h5>
            </div>
            <div *ngIf="_user.paymode == 'prepaid'">
                <h5 class="col-12">
                    <mat-icon  aria-hidden="false">credit_card</mat-icon> type de payement: Prépaiement
                  </h5>
                  <h5 class="col-12">
                      <mat-icon aria-hidden="false">money</mat-icon> Votre Solde : {{_user.solde}} €
                  </h5>
                </div>
            <div *ngIf="_user.paymode == 'direct'">
              <h5 class="col-12">
                type de payement: direct
              </h5>
            </div>

          </div> -->


        <!-- <div class="col-3">
              <div class="row justify-content-center">
                <button class="col-8" mat-stroked-button color="primary">Modifier</button>
              </div>
            </div>
            <div class="col-6">
                <div class="row justify-content-center">
                  <button class="col-4" mat-stroked-button color="primary">Détail</button>
                </div>
              </div>
              <div *ngIf="_user.paymode == 'paydebit' || _user.paymode == 'prepaid'" class="col-3">
                  <div class="row justify-content-center">
                    <button class="col-6" mat-stroked-button color="primary">Créditer</button>
                  </div>
                </div> -->

    <!-- <div class="row">
          <div class=" col-md-3">
            <div class="row">
              <div class="col-12">
                {{_currentUser.firstname}}
              </div>
              <div class="col-12">
                {{_currentUser.lastname}}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              
                
            </div>
          </div>

          <div class="col-12">
            <div class="row justify-content-end">
             
            </div>
          </div>
        </div> -->

